
import MenuBar from './MenuBar.vue'
import ConfigInfoBar from './ConfigInfoBar.vue'
import TreeView from './TreeView.vue'
import TableView from './TableView.vue'
import SnippetView from './SnippetView.vue'
import NotificationSnackBar from './NotificationSnackBar.vue'

import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      getDarkMode: 'getDarkMode',
      getTaskStatus: 'getTaskStatus',
    }),
  },
  methods: {
    ...mapActions({
      fetchCfgFromServerByName: 'fetchCfgFromServerByName',
      setSnackBarText: 'setSnackBarText',
      setStartLoadingConfig: 'setStartLoadingConfig',
      setConfigLoaded: 'setConfigLoaded',
      clearStoreState: 'clearStoreState',
    }),
  },
  components: {
    MenuBar,
    ConfigInfoBar,
    TreeView,
    TableView,
    SnippetView,
    NotificationSnackBar,
  },
})
export default class CfgView extends Vue {
  @Watch('$route', { immediate: true, deep: true })
  // eslint-disable-next-line no-unused-vars
  onUrlChange(newVal: any) {
    console.log('CFG:' + this.$route.query.cfg)
    console.log('DB:' + this.$route.query.db)

    if (this.$route.query.cfg != undefined && this.$route.query.db != undefined)
      this.openConfig()
  }

  private name: any = 'CfgView'
  private file: any = null
  private fileContent: any = null

  //Vuex getters
  private getDarkMode!: boolean
  private getTaskStatus!: string

  //Vuex actions
  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>
  private fetchCfgFromServerByName!: (payload: {
    cfg: string
    db: string
  }) => Promise<any>
  private setStartLoadingConfig!: (payload: boolean) => Promise<any>
  private setConfigLoaded!: (payload: boolean) => Promise<any>
  private clearStoreState!: () => Promise<any>

  public mounted() {
    this.$root.$refs.mainTreeDiv = this.$refs.mainTreeView
    this.$root.$refs.mainApp = this
  }

  public created() {
    //this.$root.$refs.mainTreeDiv = this.$refs.mainTreeView
  }

  async openConfig() {
    this.setStartLoadingConfig(true)
    this.setConfigLoaded(false)
    this.clearStoreState()

    new Promise<void>(() => {
      return this.fetchCfgFromServerByName({
        cfg: this.$route.query.cfg as string,
        db: this.$route.query.db as string,
      })
        .then(() => {
          // eslint-disable-next-line no-extra-semi
          ;(this.$root.$refs.TreeView as Vue & {
            loadConfiguration: () => void
          }).loadConfiguration()
        })
        .catch((error) => {
          this.setStartLoadingConfig(false)
          this.setSnackBarText({
            snackBarText: error,
            snackBarColor: 'red',
          })
        })
    })
  }

  public switchDarkMode() {
    let darkMode = this.getDarkMode
    this.$vuetify.theme.dark = !darkMode
    this.$store.dispatch('setDarkMode', !darkMode)
  }

  public testFunctionMA() {
    //@ts-ignore
    //this.$refs.mainTreeView.$el.scrollTop = 10000
    this.$root.$refs.mainTreeDiv = this.$refs.mainTreeView
    //@ts-ignore
    this.$root.$refs.mainTreeDiv.$el.scrollTop = 15097.75
    console.log(this.$root.$refs.mainTreeDiv)
  }

  // eslint-disable-next-line no-unused-vars
  public scrollToLazyDiv(scrollTo: number) {
    //@ts-ignore
    //this.$refs.mainTreeView.$el.scrollTop = 10000
    //this.$root.$refs.mainTreeDiv = this.$refs.mainTreeView
    this.$nextTick().then(() => {
      console.log('SCROLLLL: ' + scrollTo)
      //@ts-ignore
      this.$root.$refs.mainTreeDiv.$el.scrollTop = scrollTo
    })
    //console.log(this.$root.$refs.mainTreeDiv)
  }
}
